import { render } from "./UserRegistered.vue?vue&type=template&id=e5cc9040&scoped=true"
import script from "./UserRegistered.vue?vue&type=script&lang=js"
export * from "./UserRegistered.vue?vue&type=script&lang=js"

import "./UserRegistered.vue?vue&type=style&index=0&id=e5cc9040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5cc9040"]])

export default __exports__